import React from 'react';
export function BonusSection() {
  return <section className="w-full bg-black py-16 px-4" data-id="element-53">
      <div className="max-w-5xl mx-auto" data-id="element-54">
        <div className="text-center mb-4" data-id="element-55">
          <h2 className="text-3xl sm:text-4xl font-black text-white mb-3" data-id="element-56">
            Más los <span className="text-[#00E68A]" data-id="element-57">6 Bonos Estratégicos</span>
          </h2>
          <p className="text-gray-400 text-base" data-id="element-58">
            Incluidos en las dos ofertas — sin costo extra
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-10" data-id="element-59">
          {/* Bono 1 */}
          <div className="bg-[#0a1510] border border-white/20 rounded-2xl p-6 flex flex-col" data-id="element-60">
            <div className="text-4xl font-black text-[#00E68A] mb-1" data-id="element-61">01</div>
            <div className="text-[#00E68A] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-62">
              🎁 BONO 1
            </div>
            <h3 className="text-white font-black text-lg mb-2" data-id="element-63">
              Planificación Express 12 Meses
            </h3>
            <p className="text-gray-400 text-sm mb-3" data-id="element-64">
              El año de Lengua organizado por mes para toda la secundaria en 10
              minutos
            </p>
            <div className="bg-black/50 p-3 rounded-lg border border-white/10 mb-4 flex-1" data-id="element-65">
              <p className="text-xs text-gray-300" data-id="element-66">
                <span className="text-[#00E68A] font-bold" data-id="element-67">Qué resuelve:</span>{' '}
                Llegás a cada reunión de planificación con todo listo
              </p>
            </div>
            <div className="flex items-center gap-2" data-id="element-68">
              <span className="text-gray-400 line-through text-sm" data-id="element-69">$8.000</span>
              <span className="bg-[#00E68A] text-gray-900 font-black text-sm px-3 py-1 rounded-full" data-id="element-70">
                GRATIS
              </span>
            </div>
          </div>

          {/* Bono 2 */}
          <div className="bg-[#0a1510] border border-white/20 rounded-2xl p-6 flex flex-col" data-id="element-71">
            <div className="text-4xl font-black text-[#00E68A] mb-1" data-id="element-72">02</div>
            <div className="text-[#00E68A] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-73">
              🎁 BONO 2
            </div>
            <h3 className="text-white font-black text-lg mb-2" data-id="element-74">
              30 Clases Salvavidas
            </h3>
            <p className="text-gray-400 text-sm mb-3" data-id="element-75">
              Para cuando no tenés nada listo: abrís una ficha y la clase
              funciona
            </p>
            <div className="bg-black/50 p-3 rounded-lg border border-white/10 mb-4 flex-1" data-id="element-76">
              <p className="text-xs text-gray-300" data-id="element-77">
                <span className="text-[#00E68A] font-bold" data-id="element-78">Qué resuelve:</span>{' '}
                Los lunes difíciles, las semanas caóticas, los imprevistos de
                último momento
              </p>
            </div>
            <div className="flex items-center gap-2" data-id="element-79">
              <span className="text-gray-400 line-through text-sm" data-id="element-80">
                $10.000
              </span>
              <span className="bg-[#00E68A] text-gray-900 font-black text-sm px-3 py-1 rounded-full" data-id="element-81">
                GRATIS
              </span>
            </div>
          </div>

          {/* Bono 3 */}
          <div className="bg-[#0a1510] border border-white/20 rounded-2xl p-6 flex flex-col" data-id="element-82">
            <div className="text-4xl font-black text-[#00E68A] mb-1" data-id="element-83">03</div>
            <div className="text-[#00E68A] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-84">
              🎁 BONO 3
            </div>
            <h3 className="text-white font-black text-lg mb-2" data-id="element-85">
              Banco de Textos Literarios por Nivel
            </h3>
            <p className="text-gray-400 text-sm mb-3" data-id="element-86">
              Selección de textos narrativos, poéticos y no literarios con
              actividades incluidas
            </p>
            <div className="bg-black/50 p-3 rounded-lg border border-white/10 mb-4 flex-1" data-id="element-87">
              <p className="text-xs text-gray-300" data-id="element-88">
                <span className="text-[#00E68A] font-bold" data-id="element-89">Qué resuelve:</span>{' '}
                Nunca más buscás textos el domingo a la noche
              </p>
            </div>
            <div className="flex items-center gap-2" data-id="element-90">
              <span className="text-gray-400 line-through text-sm" data-id="element-91">$7.000</span>
              <span className="bg-[#00E68A] text-gray-900 font-black text-sm px-3 py-1 rounded-full" data-id="element-92">
                GRATIS
              </span>
            </div>
          </div>

          {/* Bono 4 */}
          <div className="bg-[#0a1510] border border-white/20 rounded-2xl p-6 flex flex-col" data-id="element-93">
            <div className="text-4xl font-black text-[#00E68A] mb-1" data-id="element-94">04</div>
            <div className="text-[#00E68A] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-95">
              🎁 BONO 4
            </div>
            <h3 className="text-white font-black text-lg mb-2" data-id="element-96">
              Guía de Géneros Discursivos para Docentes
            </h3>
            <p className="text-gray-400 text-sm mb-3" data-id="element-97">
              Guía práctica para abordar cada tipo textual con confianza y
              claridad
            </p>
            <div className="bg-black/50 p-3 rounded-lg border border-white/10 mb-4 flex-1" data-id="element-98">
              <p className="text-xs text-gray-300" data-id="element-99">
                <span className="text-[#00E68A] font-bold" data-id="element-100">Qué resuelve:</span>{' '}
                Explicás cualquier género con seguridad, en cualquier año
              </p>
            </div>
            <div className="flex items-center gap-2" data-id="element-101">
              <span className="text-gray-400 line-through text-sm" data-id="element-102">$6.000</span>
              <span className="bg-[#00E68A] text-gray-900 font-black text-sm px-3 py-1 rounded-full" data-id="element-103">
                GRATIS
              </span>
            </div>
          </div>

          {/* Bono 5 */}
          <div className="bg-[#0a1510] border border-white/20 rounded-2xl p-6 flex flex-col" data-id="element-104">
            <div className="text-4xl font-black text-[#00E68A] mb-1" data-id="element-105">05</div>
            <div className="text-[#00E68A] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-106">
              🎁 BONO 5
            </div>
            <h3 className="text-white font-black text-lg mb-2" data-id="element-107">
              Kit de Actividades para Fechas Literarias
            </h3>
            <p className="text-gray-400 text-sm mb-3" data-id="element-108">
              Día del Libro, Día de la Lengua, efemérides argentinas +
              actividades listas
            </p>
            <div className="bg-black/50 p-3 rounded-lg border border-white/10 mb-4 flex-1" data-id="element-109">
              <p className="text-xs text-gray-300" data-id="element-110">
                <span className="text-[#00E68A] font-bold" data-id="element-111">Qué resuelve:</span>{' '}
                Las fechas especiales resueltas sin esfuerzo adicional
              </p>
            </div>
            <div className="flex items-center gap-2" data-id="element-112">
              <span className="text-gray-400 line-through text-sm" data-id="element-113">$9.000</span>
              <span className="bg-[#00E68A] text-gray-900 font-black text-sm px-3 py-1 rounded-full" data-id="element-114">
                GRATIS
              </span>
            </div>
          </div>

          {/* Bono 6 */}
          <div className="bg-[#0a1510] border border-white/20 rounded-2xl p-6 flex flex-col" data-id="element-115">
            <div className="text-4xl font-black text-[#00E68A] mb-1" data-id="element-116">06</div>
            <div className="text-[#00E68A] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-117">
              🎁 BONO 6
            </div>
            <h3 className="text-white font-black text-lg mb-2" data-id="element-118">
              Vocabulario Visual por Año
            </h3>
            <p className="text-gray-400 text-sm mb-3" data-id="element-119">
              120 láminas digitales con vocabulario literario y lingüístico
              organizadas por nivel
            </p>
            <div className="bg-black/50 p-3 rounded-lg border border-white/10 mb-4 flex-1" data-id="element-120">
              <p className="text-xs text-gray-300" data-id="element-121">
                <span className="text-[#00E68A] font-bold" data-id="element-122">Qué resuelve:</span>{' '}
                Tus alumnos aprenden el lenguaje de la materia de manera visual
                y permanente
              </p>
            </div>
            <div className="flex items-center gap-2" data-id="element-123">
              <span className="text-gray-400 line-through text-sm" data-id="element-124">$5.000</span>
              <span className="bg-[#00E68A] text-gray-900 font-black text-sm px-3 py-1 rounded-full" data-id="element-125">
                GRATIS
              </span>
            </div>
          </div>
        </div>

        <div className="border border-white/20 rounded-2xl p-6 text-center bg-[#0a100d]" data-id="element-126">
          <p className="text-[#00E68A] text-sm font-semibold mb-1 uppercase tracking-widest" data-id="element-127">
            Valor total de los 6 Bonos
          </p>
          <div className="flex items-center justify-center gap-3" data-id="element-128">
            <span className="text-gray-400 line-through text-xl" data-id="element-129">$45.000</span>
            <p className="text-green-400 text-2xl font-black tracking-wide" data-id="element-130">
              🎁 GRATIS — Solo con tu PROFEPACK
            </p>
          </div>
          <p className="text-gray-400 text-sm mt-2" data-id="element-131">
            Incluidos en las dos ofertas. Siempre.
          </p>
        </div>
      </div>
    </section>;
}